import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { GenericRowDirection } from './interfaces';
import { useGenericRow } from './use-generic-row';
export const GenericRow = React.memo((props) => {
    const { definition, direction, realAngle, dataHook = '', labelIndexOffset = 0, reverse = false } = props;
    const { labels, getSeatPosition } = useGenericRow(props);
    const { Seat } = useContext(ComponentContext);
    const renderSeats = () => labels.map((label, index) => {
        const labelIndex = reverse ? labels.length - index - 1 : index;
        const seatIndex = labelIndex + labelIndexOffset;
        const position = {
            x: direction === GenericRowDirection.HORIZONTAL ? getSeatPosition(index) : 0,
            y: direction === GenericRowDirection.VERTICAL ? getSeatPosition(index) : 0,
        };
        return (React.createElement(Seat, { x: position.x, y: position.y, definition: definition, label: label, key: label, realAngle: realAngle, index: seatIndex }));
    });
    return React.createElement("svg", { "data-hook": dataHook }, renderSeats());
});
//# sourceMappingURL=generic-row.js.map